export function createStyles<ClassKey extends string>(x: Record<ClassKey, CSSRules>) {
  return x;
}
